<!-- Use form binding case -->
@if (form && formControlNameInput) {
  <div [class.form-group]="type !== 'radio' && label" [formGroup]="form" [class]="wrapperClass">
    @if (label && state !== 'details' && type !== 'radio' && type !== 'checkbox' && type !== 'dateRange') {
      <label [for]="id" class="form-label" [class]="labelClass"
        >{{ label | translate }}
        @if (editable && isRequired(formControlNameInput)) {
          <span class="color-danger"
            >*
            <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
          </span>
        }
      </label>
    }
    @if (label && state === 'details' && type !== 'radio' && type !== 'checkbox' && type !== 'dateRange') {
      <div class="form-label">{{ label | translate }}</div>
    }
    @if (editable) {
      @switch (type) {
        @case ('text') {
          <div [class]="class">
            <input [id]="id" [name]="id" type="text" pInputText [formControlName]="formControlNameInput" [attr.tabindex]="tabindex" [placeholder]="placeholder | translate" />
          </div>
        }
        @case ('password') {
          <div [class]="class">
            <input [id]="id" [name]="id" type="password" pInputText [formControlName]="formControlNameInput" [attr.tabindex]="tabindex" [placeholder]="placeholder | translate" />
          </div>
        }
        @case ('number') {
          <div [class]="class">
            @if (!numberInputDecimal) {
              <input
                [id]="id"
                [name]="id ? true : null"
                [formControlName]="formControlNameInput"
                type="number"
                [attr.tabindex]="tabindex"
                pInputText
                [placeholder]="placeholder | translate"
                />
            }
            @if (numberInputDecimal) {
              <p-inputNumber
                [inputId]="id"
                [formControlName]="formControlNameInput"
                [useGrouping]="false"
                mode="decimal"
                [tabindex]="+tabindex"
                [styleClass]="class"
                [inputStyleClass]="class"
                [placeholder]="placeholder | translate"
                [minFractionDigits]="numberInputDecimal"
                [maxFractionDigits]="numberInputDecimal"
              ></p-inputNumber>
            }
          </div>
        }
        @case ('textarea') {
          <div [class]="class">
            <textarea [id]="id" [name]="id" [formControlName]="formControlNameInput" pInputTextarea [attr.tabindex]="tabindex" class="w-stretch" [rows]="textAreaRows"></textarea>
          </div>
        }
        @case ('dropdown') {
          <div [class]="class">
            @if (!listConfig?.template && !listConfig.initUsingSelectItemInterface) {
              <p-select
                [name]="id"
                [tabindex]="+tabindex"
                [formControlName]="formControlNameInput"
                appendTo="body"
                [scrollHeight]="listConfig?.scrollHeight || '200px'"
                [styleClass]="wrapperClass"
                (onChange)="onChange.emit($event)"
                [filter]="listConfig.filter"
                [showClear]="listConfig.showClear"
                [options]="listConfig.data"
                [optionValue]="listConfig.optionValue"
                [optionLabel]="listConfig.optionLabel"
                [inputId]="id"
                [placeholder]="placeholder | translate"
                >
              </p-select>
            }
            @if (!listConfig?.template && listConfig.initUsingSelectItemInterface) {
              <p-select
                [name]="id"
                [tabindex]="+tabindex"
                [formControlName]="formControlNameInput"
                appendTo="body"
                [scrollHeight]="listConfig?.scrollHeight || '200px'"
                [styleClass]="wrapperClass"
                (onChange)="onChange.emit($event)"
                [filter]="listConfig.filter"
                [showClear]="listConfig.showClear"
                [options]="listConfig.data"
                [inputId]="id"
                [placeholder]="placeholder | translate"
                >
              </p-select>
            }
            @if (listConfig?.template && !listConfig.initUsingSelectItemInterface) {
              <p-select
                [name]="id"
                [tabindex]="+tabindex"
                [formControlName]="formControlNameInput"
                [showClear]="listConfig.showClear"
                [filter]="listConfig.filter"
                [styleClass]="wrapperClass"
                [options]="listConfig.data"
                appendTo="body"
                [scrollHeight]="listConfig?.scrollHeight || '200px'"
                (onChange)="onChange.emit($event)"
                [optionLabel]="!listConfig.selectedItemTemplate ? listConfig.templateKey : null"
                [optionValue]="listConfig.template === 'icon' ? listConfig.optionValue : listConfig.selectedItemTemplate ? listConfig.optionValue : null"
                [inputId]="id"
                [placeholder]="placeholder | translate"
                >
                <ng-template pTemplate="item" let-item>
                  @if (listConfig.template === 'text') {
                    <span>
                      @if (listConfig.templateKey) {
                        {{ item[listConfig.templateKey] }}
                      } @else {
                        {{ item }}
                      }
                    </span>
                  }
                  @if (listConfig.template === 'translated') {
                    <div>
                      @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                        <span>
                          @if (listConfig.templateKey) {
                            {{ item[listConfig.templateKey] | translate }}
                          } @else {
                            {{ item | translate }}
                          }
                        </span>
                      }
                      @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                        <span>
                          @if (listConfig.templateKey) {
                            {{ listConfig.translatePrevLabel + item[listConfig.templateKey] | translate }}
                          } @else {
                            {{ listConfig.translatePrevLabel + item | translate }}
                          }
                        </span>
                      }
                      @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                        <span>
                          @if (listConfig.templateKey) {
                            {{
                            listConfig.translatePrevLabel + item[listConfig.templateKey].toUpperCase() | translate
                            }}
                          } @else {
                            {{ listConfig.translatePrevLabel + item.toUpperCase() | translate }}
                          }
                        </span>
                      }
                    </div>
                  }
                  @if (listConfig.template === 'doubleWithSpace') {
                    <span>
                      @if (listConfig.templateKey) {
                        {{ item?.[listConfig.templateKey] }}&nbsp;{{ item?.[listConfig.secondTemplateKey] }}
                      } @else {
                        {{ item }}
                      }
                    </span>
                  }
                  @if (listConfig.template === 'doubleWithIdNumber') {
                    <span>
                      @if (listConfig.templateKey) {
                        {{ item?.[listConfig.templateKey] }}&nbsp;{{ item?.[listConfig.secondTemplateKey] }}
                        @if (item?.id_number) {
                          <span>&nbsp;({{ item.id_number }})</span>
                        }
                      } @else {
                        {{ item }}
                      }
                    </span>
                  }
                  @if (listConfig.template === 'valueAndAvatar') {
                    <div>
                      <div class="row-inline" (click)="onClick.emit(item)" (keydown.enter)="onClick.emit(item)" tabindex="0" role="button">
                        @if (!conditionCallbackFunction(item)) {
                          <p-avatar
                            class="pr-5"
                            shape="circle"
                            [style]="{ 'background-color': '#C9D4FA' }"
                            [label]="labelCallbackFunction(listConfig.templateKey ? item[listConfig.templateKey] : item)"
                          ></p-avatar>
                        }
                        @if (conditionCallbackFunction(item)) {
                          <p-avatar [image]="conditionCallbackFunction(item)" class="pr-5" shape="circle"></p-avatar>
                        }
                        <h3 class="fw-500 no-mg">{{ listConfig.templateKey ? item[listConfig.templateKey] : item }}</h3>
                      </div>
                    </div>
                  }
                  @if (listConfig.template === 'icon') {
                    <div>
                      <div class="column mb-5 no-mg">
                        <span class="row-inline" style="gap: 10px; justify-content: flex-start">
                          @if (item[listConfig.optionLabel] === 'employees' || item[listConfig.optionLabel] === 'authorized') {
                            <span
                              [ngClass]="item[listConfig.optionLabel] === 'employees' ? 'bg-color-primary' : 'bg-color-success'"
                              style="width: 6px; height: 6px; border-radius: 6px"
                            ></span>
                          }
                          <h4 class="no-mg">{{ listConfig.templateKey ? item[listConfig.templateKey] : item }}</h4>
                        </span>
                      </div>
                    </div>
                  }
                  @if (listConfig.template === 'valueFromCallback') {
                    <div>
                      {{ labelCallbackFunction(item) }}
                    </div>
                  }
                </ng-template>
                @if (listConfig.selectedItemTemplate; as selectedItem) {
                  <ng-template pTemplate="selectedItem" let-selectedItem>
                    @if (listConfig.template === 'text') {
                      <span>
                        @if (listConfig.templateKey) {
                          {{ selectedItem[listConfig.templateKey] }}
                        } @else {
                          {{ selectedItem }}
                        }
                      </span>
                    }
                    @if (listConfig.template === 'translated') {
                      <div>
                        @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                          <span>
                            @if (listConfig.templateKey) {
                              {{ selectedItem[listConfig.templateKey] | translate }}
                            } @else {
                              {{ selectedItem | translate }}
                            }
                          </span>
                        }
                        @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                          <span>
                            @if (listConfig.templateKey) {
                              {{ listConfig.translatePrevLabel + selectedItem[listConfig.templateKey] | translate }}
                            } @else {
                              {{ listConfig.translatePrevLabel + selectedItem | translate }}
                            }
                          </span>
                        }
                        @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                          <span>
                            @if (listConfig.templateKey) {
                              {{
                              listConfig.translatePrevLabel + selectedItem[listConfig.templateKey].toUpperCase() | translate
                              }}
                            } @else {
                              {{ listConfig.translatePrevLabel + selectedItem.toUpperCase() | translate }}
                            }
                          </span>
                        }
                      </div>
                    }
                    @if (listConfig.template === 'valueAndAvatar') {
                      <div>
                        <div class="row-inline" (click)="onClick.emit(selectedItem)" (keydown.enter)="onClick.emit(selectedItem)" tabindex="0" role="button">
                          @if (!conditionCallbackFunction(selectedItem)) {
                            <p-avatar
                              class="pr-5"
                              shape="circle"
                              [style]="{ 'background-color': '#C9D4FA' }"
                              [label]="labelCallbackFunction(listConfig.templateKey ? selectedItem[listConfig.templateKey] : selectedItem)"
                            ></p-avatar>
                          }
                          @if (conditionCallbackFunction(selectedItem)) {
                            <p-avatar [image]="conditionCallbackFunction(selectedItem)" class="pr-5" shape="circle"></p-avatar>
                          }
                          <h3 class="fw-500 no-mg">{{ listConfig.templateKey ? selectedItem[listConfig.templateKey] : selectedItem }}</h3>
                        </div>
                      </div>
                    }
                    @if (listConfig.template === 'valueFromCallback') {
                      <div>
                        {{ labelCallbackFunction(selectedItem) }}
                      </div>
                    }
                    @if (listConfig.template === 'doubleWithSpace') {
                      <span>
                        @if (listConfig.templateKey) {
                          {{ selectedItem?.[listConfig.templateKey] }}&nbsp;{{ selectedItem?.[listConfig.secondTemplateKey] }}
                        } @else {
                          {{ selectedItem }}
                        }
                      </span>
                    }
                    @if (listConfig.template === 'doubleWithIdNumber') {
                      <span>
                        @if (listConfig.templateKey) {
                          {{ selectedItem?.[listConfig.templateKey] }}&nbsp;{{ selectedItem?.[listConfig.secondTemplateKey] }}
                          @if (selectedItem?.id_number) {
                            <span>&nbsp;({{ selectedItem.id_number }})</span>
                          }
                        } @else {
                          {{ selectedItem }}
                        }
                      </span>
                    }
                  </ng-template>
                }
              </p-select>
            }
          </div>
        }
        @case ('multiselect') {
          <div [class]="class">
            @if (!listConfig?.template) {
              <p-multiSelect
                [options]="listConfig.data"
                [tabindex]="+tabindex"
                [display]="listConfig.multiSelectionDisplay"
                [formControlName]="formControlNameInput"
                appendTo="body"
                [scrollHeight]="listConfig?.scrollHeight || '200px'"
                [name]="id"
                [emptyMessage]="listConfig.emptyMessage"
                [filter]="listConfig.filter"
                [showHeader]="listConfig.filter"
                [inputId]="id"
                [optionValue]="listConfig.optionValue"
                [optionLabel]="listConfig.optionLabel"
                [placeholder]="placeholder | translate"
                [virtualScroll]="listConfig.lazy"
                [virtualScrollItemSize]="listConfig.lazy ? 34 : null"
                [lazy]="listConfig.lazy"
                (onLazyLoad)="onLazyLoad.emit($event)"
                [selectionLimit]="listConfig.selectionLimit"
                [filterBy]="listConfig.filterBy"
                [virtualScrollOptions]="listConfig.lazy ? { showLoader: true, delay: 250 } : null"
                (onPanelShow)="onMultiselectPanelShow()"
                >
              </p-multiSelect>
            }
            @if (listConfig?.template) {
              <p-multiSelect
                [options]="listConfig.data"
                appendTo="body"
                [tabindex]="+tabindex"
                [emptyMessage]="listConfig.emptyMessage"
                [display]="listConfig.multiSelectionDisplay"
                [scrollHeight]="listConfig?.scrollHeight || '200px'"
                [formControlName]="formControlNameInput"
                [name]="id"
                [filter]="listConfig.filter"
                [filterBy]="listConfig.filterBy"
                [showHeader]="listConfig.filter"
                [inputId]="id"
                [optionValue]="listConfig.optionValue"
                [placeholder]="listConfig.multiSelectionEmptyLabel || placeholder | translate"
                [optionDisabled]="listConfig.optionDisabled"
                [virtualScroll]="listConfig.lazy"
                [virtualScrollItemSize]="listConfig.lazy ? 34 : null"
                [lazy]="listConfig.lazy"
                (onLazyLoad)="onLazyLoad.emit($event)"
                [selectionLimit]="listConfig.selectionLimit"
                [virtualScrollOptions]="listConfig.lazy ? { showLoader: true, delay: 250 } : null"
                (onPanelShow)="onMultiselectPanelShow()"
                >
                <ng-template pTemplate="item" let-item>
                  @if (listConfig.template === 'text') {
                    <span>
                      @if (listConfig.templateKey) {
                        {{ item?.[listConfig.templateKey] }}
                      } @else {
                        {{ item }}
                      }
                    </span>
                  }
                  @if (listConfig.template === 'translated') {
                    <div>
                      @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                        <span>
                          @if (listConfig.templateKey) {
                            {{ item?.[listConfig.templateKey] | translate }}
                          } @else {
                            {{ item | translate }}
                          }
                        </span>
                      }
                      @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                        <span>
                          @if (listConfig.templateKey) {
                            {{ listConfig.translatePrevLabel + item?.[listConfig.templateKey] | translate }}
                          } @else {
                            {{ listConfig.translatePrevLabel + item | translate }}
                          }
                        </span>
                      }
                      @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                        <span>
                          @if (listConfig.templateKey) {
                            {{
                            listConfig.translatePrevLabel + item?.[listConfig.templateKey].toUpperCase() | translate
                            }}
                          } @else {
                            {{ listConfig.translatePrevLabel + item.toUpperCase() | translate }}
                          }
                        </span>
                      }
                    </div>
                  }
                  @if (listConfig.template === 'doubleWithSpace') {
                    <span>
                      @if (listConfig.templateKey) {
                        <div class="column mb-5 no-mg">
                          <span class="row-inline" style="gap: 6px; justify-content: flex-start">
                            @if (item[listConfig.optionLabel] === 'employees' || item[listConfig.optionLabel] === 'authorized') {
                              <span
                                [ngClass]="item[listConfig.optionLabel] === 'employees' ? 'bg-color-primary' : 'bg-color-success'"
                                style="width: 6px; height: 6px; border-radius: 6px"
                              ></span>
                            }
                            <h6 class="no-mg">{{ item?.[listConfig.templateKey] }}&nbsp;{{ item?.[listConfig.secondTemplateKey] }}</h6>
                          </span>
                        </div>
                      } @else {
                        {{ item }}
                      }
                    </span>
                  }
                  @if (listConfig.template === 'doubleWithIdNumber') {
                    <span>
                      @if (listConfig.templateKey) {
                        <div class="column mb-5 no-mg">
                          <span class="row-inline" style="gap: 6px; justify-content: flex-start">
                            @if (item[listConfig.optionLabel] === 'employees' || item[listConfig.optionLabel] === 'authorized') {
                              <span
                                [ngClass]="item[listConfig.optionLabel] === 'employees' ? 'bg-color-primary' : 'bg-color-success'"
                                style="width: 6px; height: 6px; border-radius: 6px"
                              ></span>
                            }
                            <h6 class="no-mg">
                              {{ item?.[listConfig.templateKey] }}&nbsp;{{ item?.[listConfig.secondTemplateKey] }}
                              @if (item?.id_number) {
                                <span>&nbsp;({{ item.id_number }})</span>
                              }
                            </h6>
                          </span>
                        </div>
                      } @else {
                        {{ item }}
                      }
                    </span>
                  }
                  @if (listConfig.template === 'valueFromCallback') {
                    <div>
                      {{ labelCallbackFunction(item) }}
                    </div>
                  }
                </ng-template>
                <ng-template pTemplate="selectedItems" let-selectedItems>
                  @if (selectedItems?.length) {
                    <div class="row-inline">
                      @for (val of selectedItems.sort(); track val; let IsLast = $last) {
                        <span>
                          @if (listConfig.template === 'text') {
                            <span>
                              @if (listConfig.templateKey) {
                                {{ val[listConfig.templateKey] }}
                              } @else {
                                {{ val }}
                              }
                            </span>
                          }
                          @if (listConfig.template === 'translated') {
                            <div>
                              @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                                <span>
                                  @if (listConfig.templateKey) {
                                    {{ getListConfigObjectByKey(val)?.[listConfig.templateKey] | translate }}
                                  } @else {
                                    {{ val | translate }}
                                  }
                                </span>
                              }
                              @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                                <span>
                                  @if (listConfig.templateKey) {
                                    {{
                                    listConfig.translatePrevLabel + getListConfigObjectByKey(val)?.[listConfig.templateKey] | translate
                                    }}
                                  } @else {
                                    {{ listConfig.translatePrevLabel + val | translate }}
                                  }
                                </span>
                              }
                              @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                                <span>
                                  @if (listConfig.templateKey) {
                                    {{
                                    listConfig.translatePrevLabel + getListConfigObjectByKey(val)?.[listConfig.templateKey].toUpperCase() | translate
                                    }}
                                  } @else {
                                    {{ listConfig.translatePrevLabel + val.toUpperCase() | translate }}
                                  }
                                </span>
                              }
                              @if (!IsLast) {
                                <span> {{ listConfig.multiSelectionSeparationValue }}</span>
                              }
                            </div>
                          }
                          @if (listConfig.template === 'doubleWithSpace') {
                            <span>
                              @if (listConfig.templateKey) {
                                {{ getListMultiSelectedItemsTemplate(val) }}
                              } @else {
                                {{ val }}
                              }
                              @if (!IsLast) {
                                <span> {{ listConfig.multiSelectionSeparationValue }}</span>
                              }
                            </span>
                          }
                          @if (listConfig.template === 'doubleWithIdNumber') {
                            <span>
                              @if (listConfig.templateKey) {
                                {{ getListMultiSelectedItemsTemplateWithId(val) }}
                              } @else {
                                {{ val }}
                              }
                              @if (!IsLast) {
                                <span> {{ listConfig.multiSelectionSeparationValue }}</span>
                              }
                            </span>
                          }
                          @if (listConfig.template === 'valueFromCallback') {
                            <div>
                              {{ labelCallbackFunction(getListConfigObjectByKey(val)) }}
                              @if (!IsLast) {
                                <span> {{ listConfig.multiSelectionSeparationValue }}</span>
                              }
                            </div>
                          }
                        </span>
                      }
                    </div>
                  }
                </ng-template>
                @if (listConfig.lazy; as options) {
                  <ng-template pTemplate="loader" let-options="options">
                    <div class="flex align-items-center py-2 px-3 pl-10 pr-10" style="height: 38px">
                      <p-skeleton width="100%" height="1rem"></p-skeleton>
                    </div>
                  </ng-template>
                }
              </p-multiSelect>
            }
          </div>
        }
        @case ('date') {
          <div [class]="class">
            <p-inputMask
              [inputId]="id"
              mask="99/99/9999"
              [name]="id"
              [style]="{ direction: 'ltr' }"
              [tabindex]="'{{tabindex}}'"
              [formControlName]="formControlNameInput"
              (change)="maskService.maskDateValueChange($event, form, formControlNameInput)"
              [placeholder]="dateTimeConfig.format"
            ></p-inputMask>
          </div>
        }
        @case ('mobile') {
          <div [class]="class">
            <app-mobile-with-country-code-input
              [form]="form"
              [equalSize]="true"
              [countryCodeKey]="countryCodeKey"
              [mobileKey]="mobileKey"
              [tabindex]="tabindex"
              [required]="mobileIsRequired"
              [readOnly]="readonly"
              [setDefaultCodeByClient]="setDefaultCodeByClient !== undefined ? setDefaultCodeByClient : state === 'create'"
              [inputClass]="class"
              [mobileInputId]="id"
              [countryInputId]="id + '1'"
            ></app-mobile-with-country-code-input>
          </div>
        }
        @case ('email') {
          <div [class]="class">
            <input
              [id]="id"
              [name]="id"
              type="text"
              pInputText
              [formControlName]="formControlNameInput"
              email
              [attr.tabindex]="tabindex"
              pKeyFilter="email"
              [placeholder]="placeholder | translate"
              />
          </div>
        }
        @case ('radio') {
          <div>
            <fieldset class="form-group" [class]="wrapperClass">
              <legend class="form-label" [class.mb-5]="state === 'details'" [class]="labelClass">
                {{ label | translate }}
              </legend>
              <div [class]="radioConfig.additionalClasses">
                <div class="cell">
                  <label class="form-radio sm transparent" [for]="id + '_true'">
                    <input
                      [formControlName]="formControlNameInput"
                      type="radio"
                      [attr.tabindex]="tabindex"
                      [id]="id + '_true'"
                      (change)="onChange.emit($event)"
                      [value]="radioConfig.trueValue"
                      [name]="formControlNameInput"
                      /><i aria-hidden="true"></i> <span class="form-control-label">{{ radioConfig.trueLabel | translate }}</span>
                    </label>
                  </div>
                  <div class="cell">
                    <label class="form-radio sm transparent" [for]="id + '_false'">
                      <input
                        [formControlName]="formControlNameInput"
                        type="radio"
                        [attr.tabindex]="tabindex"
                        [id]="id + '_false'"
                        [value]="radioConfig.falseValue"
                        [name]="formControlNameInput"
                        /><i aria-hidden="true"></i> <span class="form-control-label">{{ radioConfig.falseLabel | translate }}</span>
                      </label>
                    </div>
                  </div>
                </fieldset>
              </div>
            }
            @case ('checkbox') {
              <div>
                <label class="form-switcher row" [class]="wrapperClass">
                  <span [class]="labelClass">{{ label | translate }}</span>
                  <span><input type="checkbox" [formControlName]="formControlNameInput" [attr.tabindex]="tabindex" [attr.disabled]="disabled ? true : null" /><i aria-hidden="true"></i></span>
                </label>
              </div>
            }
            @case ('map-address') {
              <div>
                <div [class]="class">
                  <app-place-autocomplete [formControlName]="formControlNameInput" (placeChanged)="onChange.emit($event)"></app-place-autocomplete>
                </div>
              </div>
            }
            @case ('dateTime') {
              <div [class]="class">
                <p-inputMask
                  [inputId]="id"
                  [mask]="dateTimeConfig.mask"
                  [name]="id"
                  [style]="{ direction: 'ltr' }"
                  [formControlName]="formControlNameInput"
                  [tabindex]="'{{tabindex}}'"
                  [styleClass]="wrapperClass"
                  [placeholder]="dateTimeConfig?.format"
                ></p-inputMask>
              </div>
            }
            @case ('dateRange') {
              <div>
                <fieldset class="form-group">
                  <legend>
                    {{ label | translate }}
                    @if (isRequired(dateTimeConfig.firstRangeKey) || isRequired(dateTimeConfig.secondRangeKey)) {
                      <span class="color-danger"
                        >*
                        <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
                      </span>
                    }
                  </legend>
                  <div class="row grid-sm">
                    <div class="cell fw-50">
                      <div [class]="class">
                        <label [for]="id" class="sr-only"
                          >{{ dateTimeConfig?.firstRangePlaceholder | translate }}
                          @if (isRequired(dateTimeConfig.firstRangeKey)) {
                            <span class="color-danger"
                              >*
                              <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
                            </span>
                          }
                        </label>
                        <p-datepicker
                          [inputId]="id"
                          [formControlName]="dateTimeConfig?.firstRangeKey"
                          [tabindex]="+tabindex"
                          [placeholder]="dateTimeConfig?.firstRangePlaceholder | translate"
                          >
                      </p-datepicker>
                      @if (dateTimeConfig?.iconClass) {
                        <i [class]="dateTimeConfig?.iconClass"></i>
                      }
                    </div>
                  </div>
                  <div class="cell fw-50">
                    <div [class]="class">
                      <label [for]="rangSecondId" class="sr-only"
                        >{{ dateTimeConfig?.secondRangePlaceholder | translate }}
                        @if (isRequired(dateTimeConfig.firstRangeKey)) {
                          <span class="color-danger"
                            >*
                            <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
                          </span>
                        }
                      </label>
                      <p-datepicker
                        [inputId]="rangSecondId"
                        [formControlName]="dateTimeConfig?.secondRangeKey"
                        [tabindex]="+tabindex"
                        [placeholder]="dateTimeConfig?.secondRangePlaceholder | translate"
                        >
                      </p-datepicker>
                      @if (dateTimeConfig?.iconClass) {
                        <i [class]="dateTimeConfig?.iconClass"></i>
                      }
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          }
          @case ('daysRange') {
            <div [class]="class" class="row" style="width: fit-content; gap: 20px">
              <p-select
                [name]="id"
                [formControlName]="formControlNameInput"
                [filter]="listConfig.filter"
                [appendTo]="'body'"
                [showClear]="listConfig.showClear"
                [options]="listConfig.data"
                [optionValue]="listConfig.optionValue"
                [optionLabel]="listConfig.optionLabel"
                [inputId]="id"
                [placeholder]="placeholder | translate"
                (onChange)="onChange.emit($event)"
                >
              </p-select>
              <p-select
                [name]="id"
                [filter]="listConfig.filter"
                [appendTo]="'body'"
                [showClear]="listConfig.showClear"
                [options]="listConfig.data"
                [formControlName]="rangeFormControlNameInput"
                [optionValue]="listConfig.optionValue"
                [optionLabel]="listConfig.optionLabel"
                [inputId]="id + '1'"
                [placeholder]="placeholder | translate"
                (onChange)="onChange.emit($event)"
                >
              </p-select>
            </div>
          }
          @case ('timeRange') {
            <div [class]="class" class="row" style="width: fit-content; gap: 20px; display: flex">
              <div [class]="class">
                <p-inputMask
                  mask="99:99"
                  [formControlName]="formControlNameInput"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  (change)="timeRangeIsIsValid(true)"
                  [inputId]="id"
                  placeholder="HH:mm"
                ></p-inputMask>
                <i class="pi icon-time icon color-primary"></i>
              </div>
              <div [class]="class">
                <p-inputMask
                  mask="99:99"
                  [formControlName]="rangeFormControlNameInput"
                  (change)="timeRangeIsIsValid(false)"
                  (ngModelChange)="ngModelSecondValueChange.emit($event)"
                  [inputId]="id + 1"
                  placeholder="HH:mm"
                ></p-inputMask>
                <i class="pi icon-time icon color-primary"></i>
              </div>
            </div>
          }
        }
      }
      @if (!editable) {
        <h3 class="fw-500 no-mg">
          <div>
            @switch (type) {
              @case ('text') {
                <div [class]="class">
                  {{ form.get(formControlNameInput)?.value || '&nbsp;' }}
                </div>
              }
              @case ('number') {
                <div [class]="class">
                  {{ form.get(formControlNameInput)?.value }}
                </div>
              }
              @case ('textarea') {
                <div [class]="class">
                  {{ form.get(formControlNameInput)?.value }}
                </div>
              }
              @case ('dropdown') {
                <div [class]="class">
                  @if (!listConfig?.template) {
                    {{ getListConfigObjectByKey(form?.get(formControlNameInput).value)?.[listConfig.optionLabel] || '&nbsp;' }}
                  } @else {
                    @if (form?.get(formControlNameInput).hasOwnProperty && form?.get(formControlNameInput)?.value) {
                      @if (listConfig.template === 'text') {
                        <span>
                          @if (listConfig.templateKey) {
                            {{
                            getListConfigObjectByKey(form?.get(formControlNameInput).value)?.[listConfig.templateKey]
                            }}
                          } @else {
                            {{ form?.get(formControlNameInput).value }}
                          }
                        </span>
                      }
                      @if (listConfig.template === 'translated') {
                        <div>
                          @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                            <span>
                              @if (listConfig.templateKey) {
                                {{ getListConfigObjectByKey(form?.get(formControlNameInput).value)?.[listConfig.templateKey] | translate }}
                              } @else {
                                {{ form?.get(formControlNameInput).value | translate }}
                              }
                            </span>
                          }
                          @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                            <span>
                              @if (listConfig.templateKey) {
                                {{
                                listConfig.translatePrevLabel + getListConfigObjectByKey(form?.get(formControlNameInput).value)?.[listConfig.templateKey] | translate
                                }}
                              } @else {
                                {{ listConfig.translatePrevLabel + form?.get(formControlNameInput).value | translate }}
                              }
                            </span>
                          }
                          @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                            <span>
                              @if (listConfig.templateKey) {
                                {{
                                listConfig.translatePrevLabel + getListConfigObjectByKey(form?.get(formControlNameInput).value)?.[listConfig.templateKey].toUpperCase() | translate
                                }}
                              } @else {
                                {{ listConfig.translatePrevLabel + form?.get(formControlNameInput).value.toUpperCase() | translate }}
                              }
                            </span>
                          }
                        </div>
                      }
                      @if (listConfig.template === 'valueAndAvatar') {
                        <div class="row-inline">
                          <p-avatar
                            class="pr-5"
                            shape="circle"
                [label]="
                  labelCallbackFunction(
                    listConfig.templateKey
                      ? getListConfigObjectByKey(form?.get(formControlNameInput).value[listConfig.optionValue])[listConfig.templateKey]
                      : form?.get(formControlNameInput).value
                  )
                "
                            [style]="{ 'background-color': '#C9D4FA' }"
                          ></p-avatar>
                          <h3 class="fw-500 no-mg">
                            {{
                            listConfig.templateKey
                            ? getListConfigObjectByKey(form?.get(formControlNameInput).value[listConfig.optionValue])[listConfig.templateKey]
                            : form?.get(formControlNameInput).value
                            }}
                          </h3>
                        </div>
                      }
                      @if (listConfig.template === 'valueFromCallback') {
                        <div>
                          {{ labelCallbackFunction(form?.get(formControlNameInput).value) }}
                        </div>
                      }
                      @if (listConfig.template === 'doubleWithSpace') {
                        <div>
                          @if (getListConfigObjectByKey(form?.get(formControlNameInput).value)) {
                            {{ getListConfigObjectByKey(form?.get(formControlNameInput).value)[listConfig.templateKey] }}&nbsp;{{
                            getListConfigObjectByKey(form?.get(formControlNameInput).value)[listConfig.secondTemplateKey]
                            }}
                          }
                        </div>
                      }
                      @if (listConfig.template === 'doubleWithIdNumber') {
                        <div>
                          @if (getListConfigObjectByKey(form?.get(formControlNameInput).value)) {
                            {{ getListConfigObjectByKey(form?.get(formControlNameInput).value)[listConfig.templateKey] }}&nbsp;{{
                            getListConfigObjectByKey(form?.get(formControlNameInput).value)[listConfig.secondTemplateKey]
                            }}
                            @if (getListConfigObjectByKey(form?.get(formControlNameInput).value)?.id_number) {
                              <span>
                                &nbsp;({{ getListConfigObjectByKey(form?.get(formControlNameInput).value).id_number }})
                              </span>
                            }
                          }
                        </div>
                      }
                    } @else {
                      {{ '&nbsp;' }}
                    }
                  }
                </div>
              }
              @case ('multiselect') {
                <div [class]="class">
                  @if (!listConfig?.template) {
                    @for (val of form?.get(formControlNameInput).value; track val; let IsLast = $last) {
                      <div class="row-inline">
                        @if (listConfig.templateKey) {
                          {{ getListConfigObjectByKey(val)?.[listConfig.optionLabel] }}
                        } @else {
                          {{ val }}
                        }
                        @if (!IsLast) {
                          <span>{{ listConfig.multiSelectionSeparationValue }}</span>
                        }
                      </div>
                    }
                  } @else {
                    @for (val of form?.get(formControlNameInput).value; track val; let IsLast = $last) {
                      <div class="row-inline">
                        @if (listConfig.template === 'text') {
                          <span>
                            @if (listConfig.templateKey) {
                              {{ getListConfigObjectByKey(val)?.[listConfig.templateKey] }}
                            } @else {
                              {{ val }}
                            }
                            @if (!IsLast) {
                              <span>{{ listConfig.multiSelectionSeparationValue }}</span>
                            }
                          </span>
                        }
                        @if (listConfig.template === 'translated') {
                          <div>
                            @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                              <span>
                                @if (listConfig.templateKey) {
                                  {{ getListConfigObjectByKey(val)?.[listConfig.templateKey] | translate }}
                                } @else {
                                  {{ val | translate }}
                                }
                              </span>
                            }
                            @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                              <span>
                                @if (listConfig.templateKey) {
                                  {{
                                  listConfig.translatePrevLabel + getListConfigObjectByKey(val)?.[listConfig.templateKey] | translate
                                  }}
                                } @else {
                                  {{ listConfig.translatePrevLabel + val | translate }}
                                }
                              </span>
                            }
                            @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                              <span>
                                @if (listConfig.templateKey) {
                                  {{
                                  listConfig.translatePrevLabel + getListConfigObjectByKey(val)?.[listConfig.templateKey].toUpperCase() | translate
                                  }}
                                } @else {
                                  {{ listConfig.translatePrevLabel + val.toUpperCase() | translate }}
                                }
                              </span>
                            }
                            @if (!IsLast) {
                              <span>{{ listConfig.multiSelectionSeparationValue }}</span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (!form?.get(formControlNameInput).value) {
                      <span>
                        {{ '&nbsp;' }}
                      </span>
                    }
                  }
                </div>
              }
              @case ('timeRange') {
                <div [class]="class">{{ form.get(formControlNameInput)?.value }} - {{ form.get(rangeFormControlNameInput)?.value }}</div>
              }
              @case ('date') {
                <div [class]="class">
                  @if (form.get(formControlNameInput)?.value && form.get(formControlNameInput)?.value.includes('T')) {
                    {{ form.get(formControlNameInput)?.value | date: dateTimeConfig.format : dateService.timezone || '&nbsp;' }}
                  } @else {
                    {{ form.get(formControlNameInput)?.value || '&nbsp;' }}
                  }
                </div>
              }
              @case ('mobile') {
                <div>{{ form.get('country_code')?.value }}{{ form.get(formControlNameInput)?.value }}</div>
              }
              @case ('email') {
                <div [class]="class">
                  {{ form.get(formControlNameInput)?.value || '&nbsp;' }}
                </div>
              }
              @case ('radio') {
                <div>
                  <fieldset class="form-group">
                    <legend class="form-label" [class.mb-5]="state === 'details'">
                      {{ label | translate }}
                    </legend>
                    @if (radioConfig.translateValue) {
                      {{ labelCallbackFunction(form.get(formControlNameInput)?.value) | translate }}
                    } @else {
                      {{ form.get(formControlNameInput)?.value }}
                    }
                  </fieldset>
                </div>
              }
              @case ('daysRange') {
                <div [class]="class">{{ form.get(formControlNameInput)?.value }} - {{ form.get(rangeFormControlNameInput)?.value }}</div>
              }
              @case ('checkbox') {
                <div [class]="class">
                  <span>{{ label | translate }}</span>
                  <span>{{ this.booleanTranslate(form.get(formControlNameInput)?.value) | translate }}</span>
                </div>
              }
            }
          </div>
        </h3>
      }
    </div>
  }

  <!-- Use ng model binding case-->
  @if (!form) {
    <div [class.form-group]="label ? true : false">
      @if (editable && label) {
        <label [for]="id" class="form-label"
          >{{ label | translate }}
          @if (editable && isRequired(formControlNameInput)) {
            <span class="color-danger"
              >*
              <span class="sr-only">{{ 'COMMON.FORMS.FIELD_REQUIRED' | translate }}</span>
            </span>
          }
        </label>
      }
      @if (!editable && label) {
        <div>
          <span class="form-label">{{ label | translate }}</span>
        </div>
      }
      @if (editable) {
        @switch (type) {
          @case ('text') {
            <div [class]="class">
              @if (!textSearch) {
                <input
                  [id]="id"
                  [name]="id"
                  type="text"
                  pInputText
                  [(ngModel)]="ngModelValue"
                  [disabled]="disabled"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  (input)="onChange.emit(ngModelValue)"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  [placeholder]="placeholder | translate"
                  />
              }
              @if (textSearch) {
                <div class="p-inputgroup">
                  <input
                    [id]="id"
                    [name]="id"
                    [(ngModel)]="ngModelValue"
                    [style]="{ width: '120px' }"
                    type="text"
                    pInputText
                    [disabled]="disabled"
                    [class.ng-invalid]="ngModelInvalidInput && !form"
                    [class.ng-dirty]="ngModelInvalidInput && !form"
                    [placeholder]="placeholder | translate"
                    />
                  <button type="button" [style]="{ width: '64px' }" pButton pRipple [label]="'COMMON.TAGS.SEARCH' | translate" (click)="ngModelValueChange.emit(ngModelValue)"></button>
                </div>
              }
            </div>
          }
          @case ('number') {
            <div [class]="class">
              @if (!searchNumberInput) {
                <input
                  [id]="id"
                  [name]="id"
                  [(ngModel)]="ngModelValue"
                  type="number"
                  pInputText
                  [disabled]="disabled"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  (input)="onChange.emit(ngModelValue)"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  [placeholder]="placeholder | translate"
                  />
              }
              @if (searchNumberInput) {
                <div class="p-inputgroup">
                  <p-inputNumber
                    [id]="id"
                    [name]="id"
                    [(ngModel)]="ngModelValue"
                    [style]="{ width: '60px' }"
                    type="number"
                    [disabled]="disabled"
                    [class.ng-invalid]="ngModelInvalidInput && !form"
                    [useGrouping]="searchNumberInput?.useGrouping"
                    [class.ng-dirty]="ngModelInvalidInput && !form"
                    [placeholder]="placeholder | translate"
                    [min]="searchNumberInput.min || null"
                    [max]="searchNumberInput.max || null"
                  ></p-inputNumber>
                  <button type="button" pButton pRipple [label]="'COMMON.TAGS.SEARCH' | translate" (click)="ngModelValueChange.emit(ngModelValue)"></button>
                </div>
              }
            </div>
          }
          @case ('textarea') {
            <div [class]="class">
              <textarea
                [id]="id"
                z[name]="id"
                [(ngModel)]="ngModelValue"
                pInputTextarea
                class="w-stretch"
                [disabled]="disabled"
                (ngModelChange)="ngModelValueChange.emit($event)"
                [class.ng-invalid]="ngModelInvalidInput && !form"
                [class.ng-dirty]="ngModelInvalidInput && !form"
                [rows]="textAreaRows"
              ></textarea>
            </div>
          }
          @case ('dropdown') {
            <div [class]="class">
              @if (!listConfig?.template && !listConfig.initUsingSelectItemInterface) {
                <p-select
                  [name]="id"
                  [(ngModel)]="ngModelValue"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  appendTo="body"
                  [disabled]="disabled"
                  [scrollHeight]="listConfig?.scrollHeight || '200px'"
                  [appendTo]="'body'"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  (onChange)="onChange.emit($event)"
                  [filter]="listConfig.filter"
                  [showClear]="listConfig.showClear"
                  [options]="listConfig.data"
                  [optionValue]="listConfig.optionValue"
                  [optionLabel]="listConfig.optionLabel"
                  [inputId]="id"
                  [placeholder]="placeholder | translate"
                  >
                </p-select>
              }
              @if (!listConfig?.template && listConfig.initUsingSelectItemInterface) {
                <p-select
                  [name]="id"
                  [(ngModel)]="ngModelValue"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  appendTo="body"
                  [scrollHeight]="listConfig?.scrollHeight || '200px'"
                  [styleClass]="wrapperClass"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  (onChange)="onChange.emit($event)"
                  [filter]="listConfig.filter"
                  [showClear]="listConfig.showClear"
                  [options]="listConfig.data"
                  [inputId]="id"
                  [placeholder]="placeholder | translate"
                  >
                </p-select>
              }
              @if (listConfig?.template && !listConfig.initUsingSelectItemInterface) {
                <p-select
                  [name]="id"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  [(ngModel)]="ngModelValue"
                  [disabled]="disabled"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  [showClear]="listConfig.showClear"
                  [appendTo]="'body'"
                  [filter]="listConfig.filter"
                  [options]="listConfig.data"
                  appendTo="body"
                  [scrollHeight]="listConfig?.scrollHeight || '200px'"
                  [optionLabel]="!listConfig.selectedItemTemplate ? listConfig.templateKey : null"
                  (onChange)="onChange.emit($event)"
                  [optionValue]="listConfig.selectedItemTemplate ? listConfig.optionValue : null"
                  [inputId]="id"
                  [placeholder]="placeholder | translate"
                  >
                  <ng-template pTemplate="item" let-item>
                    @if (listConfig.template === 'text') {
                      <span>
                        @if (listConfig.templateKey) {
                          {{ item[listConfig.templateKey] }}
                        } @else {
                          {{ item }}
                        }
                      </span>
                    }
                    @if (listConfig.template === 'translated') {
                      <div>
                        @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                          <span>
                            @if (listConfig.templateKey) {
                              {{ item[listConfig.templateKey] | translate }}
                            } @else {
                              {{ item | translate }}
                            }
                          </span>
                        }
                        @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                          <span>
                            @if (listConfig.templateKey) {
                              {{ listConfig.translatePrevLabel + item[listConfig.templateKey] | translate }}
                            } @else {
                              {{ listConfig.translatePrevLabel + item | translate }}
                            }
                          </span>
                        }
                        @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                          <span>
                            @if (listConfig.templateKey) {
                              {{
                              listConfig.translatePrevLabel + item[listConfig.templateKey].toUpperCase() | translate
                              }}
                            } @else {
                              {{ listConfig.translatePrevLabel + item.toUpperCase() | translate }}
                            }
                          </span>
                        }
                      </div>
                    }
                    @if (listConfig.template === 'valueAndAvatar') {
                      <div>
                        <div class="row-inline" (click)="onClick.emit(item)" (keydown.enter)="onClick.emit(item)" tabindex="0" role="button">
                          @if (!conditionCallbackFunction(item)) {
                            <p-avatar
                              class="pr-5"
                              shape="circle"
                              [style]="{ 'background-color': '#C9D4FA' }"
                              [label]="labelCallbackFunction(listConfig.templateKey ? item[listConfig.templateKey] : item)"
                            ></p-avatar>
                          }
                          @if (conditionCallbackFunction(item)) {
                            <p-avatar [image]="conditionCallbackFunction(item)" class="pr-5" shape="circle"></p-avatar>
                          }
                          <h3 class="fw-500 no-mg">{{ listConfig.templateKey ? item[listConfig.templateKey] : item }}</h3>
                        </div>
                      </div>
                    }
                  </ng-template>
                  @if (listConfig.selectedItemTemplate; as selectedItem) {
                    <ng-template pTemplate="selectedItem" let-selectedItem>
                      @if (listConfig.template === 'text') {
                        <span>
                          @if (listConfig.templateKey) {
                            {{ selectedItem[listConfig.templateKey] }}
                          } @else {
                            {{ selectedItem }}
                          }
                        </span>
                      }
                      @if (listConfig.template === 'translated') {
                        <div>
                          @if (!listConfig.whenTranslateUseUpperCase && !listConfig.translatePrevLabel) {
                            <span>
                              @if (listConfig.templateKey) {
                                {{ selectedItem[listConfig.templateKey] | translate }}
                              } @else {
                                {{ selectedItem | translate }}
                              }
                            </span>
                          }
                          @if (listConfig.translatePrevLabel && !listConfig.whenTranslateUseUpperCase) {
                            <span>
                              @if (listConfig.templateKey) {
                                {{ listConfig.translatePrevLabel + selectedItem[listConfig.templateKey] | translate }}
                              } @else {
                                {{ listConfig.translatePrevLabel + selectedItem | translate }}
                              }
                            </span>
                          }
                          @if (listConfig.translatePrevLabel && listConfig.whenTranslateUseUpperCase) {
                            <span>
                              @if (listConfig.templateKey) {
                                {{
                                listConfig.translatePrevLabel + selectedItem[listConfig.templateKey].toUpperCase() | translate
                                }}
                              } @else {
                                {{ listConfig.translatePrevLabel + selectedItem.toUpperCase() | translate }}
                              }
                            </span>
                          }
                        </div>
                      }
                      @if (listConfig.template === 'valueAndAvatar') {
                        <div>
                          <div class="row-inline" (click)="onClick.emit(selectedItem)" (keydown.enter)="onClick.emit(selectedItem)" tabindex="0" role="button">
                            @if (!conditionCallbackFunction(selectedItem)) {
                              <p-avatar
                                class="pr-5"
                                shape="circle"
                                [style]="{ 'background-color': '#C9D4FA' }"
                                [label]="labelCallbackFunction(listConfig.templateKey ? selectedItem[listConfig.templateKey] : selectedItem)"
                              ></p-avatar>
                            }
                            @if (conditionCallbackFunction(selectedItem)) {
                              <p-avatar [image]="conditionCallbackFunction(selectedItem)" class="pr-5" shape="circle"></p-avatar>
                            }
                            <h3 class="fw-500 no-mg">{{ listConfig.templateKey ? selectedItem[listConfig.templateKey] : selectedItem }}</h3>
                          </div>
                        </div>
                      }
                    </ng-template>
                  }
                </p-select>
              }
            </div>
          }
          @case ('multiselect') {
            <div [class]="class">
              @if (!listConfig?.template) {
                <p-multiSelect
                  [options]="listConfig.data"
                  [(ngModel)]="ngModelValue"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  [showClear]="listConfig.showClear"
                  appendTo="body"
                  [scrollHeight]="listConfig?.scrollHeight || '200px'"
                  [disabled]="disabled"
                  [emptyMessage]="listConfig.emptyMessage"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  [name]="id"
                  [display]="listConfig.multiSelectionDisplay"
                  [filter]="listConfig.filter"
                  [showHeader]="listConfig.showClear"
                  [inputId]="id"
                  [optionValue]="listConfig.optionValue"
                  [optionLabel]="listConfig.optionLabel"
                  [placeholder]="placeholder | translate"
                  >
                </p-multiSelect>
              }
              @if (listConfig?.template) {
                <p-multiSelect
                  [options]="listConfig.data"
                  [(ngModel)]="ngModelValue"
                  [class.ng-invalid]="ngModelInvalidInput && row"
                  [class.ng-dirty]="ngModelInvalidInput && row"
                  [showClear]="listConfig.showClear"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  [name]="id"
                  [emptyMessage]="listConfig.emptyMessage"
                  [filter]="listConfig.filter"
                  [disabled]="disabled"
                  [scrollHeight]="listConfig?.scrollHeight || '200px'"
                  [display]="listConfig.multiSelectionDisplay"
                  [showHeader]="listConfig.showClear"
                  [inputId]="id"
                  [optionValue]="listConfig.optionValue"
                  [placeholder]="listConfig.multiSelectionEmptyLabel || placeholder | translate"
                  >
                  <ng-template pTemplate="item" let-item>
                    @if (listConfig.template === 'text') {
                      <span>
                        {{ item[listConfig.templateKey] }}
                      </span>
                    }
                    @if (listConfig.template === 'translated') {
                      <div>
                        @if (!listConfig.whenTranslateUseUpperCase) {
                          <span>{{ item[listConfig.templateKey] | translate }}</span>
                        }
                        @if (listConfig.translatePrevLabel) {
                          <span>{{ listConfig.translatePrevLabel + item[listConfig.templateKey] | translate }}</span>
                        }
                        @if (listConfig.whenTranslateUseUpperCase) {
                          <span>{{ listConfig.translatePrevLabel + item[listConfig.templateKey].toUpperCase() | translate }}</span>
                        }
                      </div>
                    }
                  </ng-template>
                  <ng-template pTemplate="selectedItems" let-selectedItems>
                    @if (selectedItems?.length) {
                      <div class="row">
                        @for (val of selectedItems.sort(); track val; let IsLast = $last) {
                          <span>
                            @if (listConfig.template === 'text') {
                              <span>
                                {{ getListConfigObjectByKey(val)[listConfig.templateKey] }}
                              </span>
                            }
                            @if (listConfig.template === 'translated') {
                              <div>
                                @if (!listConfig.whenTranslateUseUpperCase) {
                                  {{ listConfig.translatePrevLabel + getListConfigObjectByKey(val)[listConfig.templateKey] | translate }}
                                } @else {
                                  {{ listConfig.translatePrevLabel + getListConfigObjectByKey(val)[listConfig.templateKey].toUpperCase() | translate }}
                                }
                                @if (!IsLast) {
                                  <span> {{ listConfig.multiSelectionSeparationValue }}</span>
                                }
                              </div>
                            }
                          </span>
                        }
                      </div>
                    }
                  </ng-template>
                </p-multiSelect>
              }
            </div>
          }
          @case ('daysRange') {
            <div [class]="class" class="row" style="width: fit-content; gap: 20px">
              <p-select
                [name]="id"
                [(ngModel)]="ngModelValue"
                [filter]="listConfig.filter"
                [appendTo]="'body'"
                [class.ng-invalid]="ngModelInvalidInput && !form"
                [class.ng-dirty]="ngModelInvalidInput && !form"
                [showClear]="listConfig.showClear"
                (ngModelChange)="ngModelValueChange.emit($event)"
                [options]="listConfig.data"
                [optionValue]="listConfig.optionValue"
                [optionLabel]="listConfig.optionLabel"
                [inputId]="id"
                [placeholder]="placeholder | translate"
                (onChange)="onChange.emit($event)"
                >
              </p-select>
              <p-select
                [name]="id"
                [(ngModel)]="ngModelSecondValue"
                [filter]="listConfig.filter"
                [class.ng-invalid]="ngModelInvalidInput && !form"
                [class.ng-dirty]="ngModelInvalidInput && !form"
                [appendTo]="'body'"
                [showClear]="listConfig.showClear"
                (ngModelChange)="ngModelSecondValueChange.emit($event)"
                [options]="listConfig.data"
                [optionValue]="listConfig.optionValue"
                [optionLabel]="listConfig.optionLabel"
                [inputId]="id + '1'"
                [placeholder]="placeholder | translate"
                (onChange)="onChange.emit($event)"
                >
              </p-select>
            </div>
          }
          @case ('timeRange') {
            <div class="row" style="width: fit-content; gap: 20px">
              <div [class]="class">
                <p-inputMask
                  mask="99:99"
                  [(ngModel)]="ngModelValue"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  (change)="timeRangeIsIsValid(true)"
                  [inputId]="id"
                  placeholder="HH:mm"
                ></p-inputMask>
                <i class="pi icon-time icon color-primary"></i>
              </div>
              <div [class]="class">
                <p-inputMask
                  mask="99:99"
                  [(ngModel)]="ngModelSecondValue"
                  (change)="timeRangeIsIsValid(false)"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  (ngModelChange)="ngModelSecondValueChange.emit($event)"
                  [inputId]="id + 1"
                  placeholder="HH:mm"
                ></p-inputMask>
                <i class="pi icon-time icon color-primary"></i>
              </div>
            </div>
          }
          @case ('dateTime') {
            <div>
              <div [class]="class">
                <p-inputMask
                  [inputId]="id"
                  [(ngModel)]="ngModelValue"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  [class.ng-invalid]="ngModelInvalidInput && !form"
                  [class.ng-dirty]="ngModelInvalidInput && !form"
                  [style]="{ direction: 'ltr' }"
                  [placeholder]="dateTimeConfig.format"
                  [disabled]="disabled"
                  [mask]="dateTimeConfig.mask"
                ></p-inputMask>
              </div>
            </div>
          }
          @case ('checkbox') {
            <div>
              <label class="form-switcher row" [class]="wrapperClass">
                <span
                  ><input
                  type="checkbox"
                  [(ngModel)]="ngModelValue"
                  (ngModelChange)="ngModelValueChange.emit($event)"
                  (onChange)="onChange.emit($event)"
                  [attr.disabled]="disabled ? true : null" /><i aria-hidden="true"></i
                ></span>
              </label>
            </div>
          }
        }
      }
      @if (!editable) {
        <h3 class="fw-500 no-mg">
          <div>
            @switch (type) {
              @case ('text') {
                <div [class]="class">
                  {{ ngModelValue }}
                </div>
              }
              @case ('number') {
                <div [class]="class">
                  {{ ngModelValue }}
                </div>
              }
              @case ('textarea') {
                <div [class]="class">
                  {{ ngModelValue }}
                </div>
              }
              @case ('dropdown') {
                <div [class]="class">
                  @if (!listConfig?.template) {
                    {{ getListConfigObjectByKey(ngModelValue)[listConfig.optionLabel] }}
                  } @else {
                    @if (listConfig.template === 'text') {
                      <span>
                        {{ getListConfigObjectByKey(ngModelValue)[listConfig.templateKey] }}
                      </span>
                    }
                    @if (listConfig.template === 'translated') {
                      <div>
                        @if (!listConfig.whenTranslateUseUpperCase) {
                          {{ listConfig.translatePrevLabel + getListConfigObjectByKey(ngModelValue)[listConfig.templateKey] | translate }}
                        } @else {
                          {{ listConfig.translatePrevLabel + getListConfigObjectByKey(ngModelValue)[listConfig.templateKey].toUpperCase() | translate }}
                        }
                      </div>
                    }
                  }
                </div>
              }
              @case ('multiselect') {
                <div [class]="class"></div>
              }
              @case ('timeRange') {
                <div [class]="class">{{ ngModelValue }} - {{ ngModelSecondValue }}</div>
              }
              @case ('dateTime') {
                <div>
                  {{ ngModelValue | date: dateTimeConfig.format : dateService.timezone }}
                </div>
              }
            }
          </div>
        </h3>
      }
    </div>
  }
